var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1960_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4463 6.22684C14.9771 6.1439 14.4938 6.10059 14.0001 6.10059C13.4461 6.10059 12.9052 6.15513 12.3825 6.25903V12.5709H6.04939C5.96115 13.0392 5.91504 13.5221 5.91504 14.0155C5.91504 14.5704 5.97338 15.112 6.08437 15.6347H12.3825V21.7719C12.9052 21.8758 13.4461 21.9304 14.0001 21.9304C14.4938 21.9304 14.9771 21.887 15.4463 21.8041V15.6347H21.9159C22.0269 15.112 22.0852 14.5704 22.0852 14.0155C22.0852 13.5221 22.0391 13.0392 21.9509 12.5709H15.4463V6.22684Z",
    fill: "url(#paint0_linear_1960_2036)",
    fillOpacity: 0.56
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4461 6.2952C14.9768 6.21225 14.4935 6.16895 13.9999 6.16895C13.4459 6.16895 12.9049 6.22349 12.3823 6.32739V12.6382H6.04935C5.96098 13.1069 5.91479 13.5901 5.91479 14.0838C5.91479 14.6384 5.97305 15.1796 6.08391 15.702H12.3823V21.8403C12.9049 21.9442 13.4459 21.9987 13.9999 21.9987C14.4935 21.9987 14.9768 21.9554 15.4461 21.8725V15.702H21.9159C22.0267 15.1796 22.085 14.6384 22.085 14.0838C22.085 13.5901 22.0388 13.1069 21.9504 12.6382H15.4461V6.2952Z",
    fill: "url(#paint1_linear_1960_2036)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1960_2036",
    x: 0.127706,
    y: 0.313252,
    width: 27.7448,
    height: 27.4047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.89367,
    result: "effect1_foregroundBlur_1960_2036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1960_2036",
    x1: 5.91504,
    y1: 14.441,
    x2: 22.0852,
    y2: 14.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1960_2036",
    x1: 5.91479,
    y1: 14.5094,
    x2: 22.085,
    y2: 14.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5F3FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon);
export default __webpack_public_path__ + "static/media/BenefitIcon.7f92669ecae64641b07b6811d7283521.svg";
export { ForwardRef as ReactComponent };